import { applyTheme } from "./slide-themes";

// Raw slide data - just content, no styling
const nxopsSlidesData = [
  {
    id: "nxops-overview",
    image: "/sliders/nxops/1_nxops.png",
    imageAlt: "NXOps command center",
    imagePosition: "right",
    kicker: "Operational Intelligence",
    title: "NXOps",
    sections: [
      {
        description: [
          "The live control tower for every sustainability initiative and asset.",
          "Monitor energy, utilities, and ESG evidence from solar arrays to EV fleets.",
          "Keep NXPlan roadmaps on track with real-time alerts, tasks, and audit trails.",
        ],
      },
    ],
  },
  {
    id: "2_key_features_of_nxops.png",
    image: "/sliders/nxops/2_key_features_of_nxops.png",
    imageAlt: "Key features of NXOps",
    imagePosition: "right",
    title: "Key features of NXOps",
    sections: [
      {
        id: "sensors",
        title: "Non-Invasive Implementation of Sensors",
        desClass: "text-sm",
        description:
          "Deploy quickly with non-invasive sensors that avoid downtime or costly retrofits.",
      },
      {
        id: "actionable-data",
        title: "Actionable Data on Equipment Performance",
        desClass: "text-sm",
        description:
          "Understand equipment performance in context, detecting inefficiencies before they impact budgets.",
      },
      {
        id: "scalable",
        title: "Scalable and Customizable Solutions",
        desClass: "text-sm",
        description:
          "Modular capabilities scale from single facilities to multi-region portfolios with ease.",
      },
    ],
  },
  {
    id: "3_integration_for_sustainability",
    image: "/sliders/nxops/3_integration_for_sustainability.png",
    imageAlt: "Integration For Sustainabilty",
    imagePosition: "right",
    title: "Integrations built for sustainability",
    sections: [
      {
        description: [
          "Connect to IoT sensors, BMS/EMS platforms, and major ERPs through open APIs.",
          "Capture utility usage, asset telemetry, and maintenance logs in near real time.",
          "Transform raw signals into insights that guide smarter operating decisions.",
        ],
      },
    ],
  },
  {
    id: "4_key_features_capabilities",
    image: "/sliders/nxops/4_key_features_capabilities.png",
    imageAlt: "Key Features & Capabilities",
    imagePosition: "right",
    title: "Designed for energy-intensive operations",
    sections: [
      {
        id: "utilization",
        title: "Focus on Fuel, Electricity, Heat and Cooling Utilization",
        desClass: "text-sm",
        description:
          "Optimise how fuel, electricity, heat, and cooling are consumed across sites.",
      },
      {
        id: "implementation",
        title: "Non-Invasive Sensor Implementation",
        desClass: "text-sm",
        description:
          "Deploy sensors without interrupting operations or triggering costly shutdowns.",
      },
      {
        id: "integration",
        title: "ERP System Integration",
        desClass: "text-sm",
        description:
          "Integrate with SAP, Oracle, Microsoft, Infor, and SAGE to synchronise budgets, assets, and sustainability reporting.",
      },
    ],
  },
];

// Apply themes to slides - alternating between skyBlue and blueTint
export const nxopsSlides = nxopsSlidesData.map((slide, index) => {
  const theme = index % 2 === 0 ? "skyBlue" : "blueTint";
  return applyTheme(slide, theme, "blueEmerald");
});
